/**
 * Created by csaba.adam on 2017. 07. 18..
 */
const COMISSION_TYPES = {
	TO_RENT: 'toRent',
	TO_SELL: 'toSell'
};

export const RealEstatePricesComponent = {
	bindings: {
		avgPrices: '<',
		sqmPriceHuf: '<',
		comissionType: '<'
	},
	templateUrl: 'real-estate-prices.html',
	controller: class RealEstatePricesComponent {
		constructor($timeout) {
			'ngInject';
			this.$timeout = $timeout;
			this.COMISSION_TYPES = COMISSION_TYPES;
		}

		$onInit() {

		}

		$onChanges(changes) {
			if (changes.avgPrices) {
				this.prices = angular.copy(this.avgPrices);
				if (this.prices && Object.keys(this.prices).length) {
					this.showPrices = true;
					this.setupPrices(this.prices);
				} else {
					this.showPrices = false;
				}
			}
			if (changes.sqmPriceHuf) {
				this.priceSqm = angular.copy(this.sqmPriceHuf);
			}
			if (changes.comissionType) {
				if (this.comissionType) {
					this.typeOfCommission = angular.copy(this.comissionType);
				}
			}
		}

		setupPrices(prices) {
			let pricesArray = Object.values(prices);
			let min = Math.min(...pricesArray);
			let max = Math.max(...pricesArray);
			this.pricesForView = [];
			for (let key in prices) {
				this.pricesForView.push({
					year: key,
					price: Math.round(prices[key] / 1000),
					height: this.getHeight(prices[key], max),
					specClass: this.getSpecClass(key, prices[key], min, max)
				});
			}
		}

		getHeight(price, max) {
			return Math.round(price / max * 100);
		}

		getSpecClass(year, price, min, max) {
			let specClass = '';
			if (price == min) {
				specClass = "m28-real-estate-prices-chart__graph--min";
			} else if (price == max) {
				specClass = "m28-real-estate-prices-chart__graph--max";
			} else if (year == new Date().getFullYear()) {
				specClass = "m28-real-estate-prices-chart__graph--current";
			} else {
				specClass = false;
			}
			if (year == new Date().getFullYear()) {
				this.thisYearPrice = price;
			}
			return specClass;
		}
	}
};
